<div>
  @switch (context) {
    @case ('nameinsured') {
      <div class="flex-column">
        <div class="heading">Named Insured</div>
        <div class="pad-top-12 pad-bottom-30 font-weight-normal gray-text">
          Named insureds are fully covered on the policy and can make policy changes.
        </div>
      </div>
    }
    @case ('listeddriver') {
      <div class="flex-column">
        <div class="heading">Listed Driver</div>
        <div class="pad-top-12 pad-bottom-30 font-weight-normal gray-text">
          Listed drivers can operate this vehicle and are fully covered on the policy.
        </div>
      </div>
    }
    @case ('nondriver') {
      <div class="flex-column">
        <div class="heading">Non-Driver</div>
        <ul class="list">
          <li>
            <span class="icon-complete green">Fully covered on this policy</span>
          </li>
          <li><span class="icon-times-thick red">Can drive this vehicle</span></li>
          <li><span class="icon-times-thick red">Can make policy changes</span></li>
        </ul>
        <div class="footer">
          If you have any further questions or concerns, please contact your agent.
        </div>
      </div>
    }
    @case ('propertynameinsured') {
      <div class="flex-column">
        <div class="heading">Name Insured</div>
        <div class="pad-top-12 pad-bottom-30 gray-text font-weight-normal">
          Named insureds are fully covered on the policy and can make policy changes.
        </div>
      </div>
    }
    @case ('propertyadditionalinsured') {
      <div class="flex-column">
        <div class="heading pad-bottom-16">Additional Insured</div>
        <ul class="list">
          <li>
            <span class="icon-complete green">Fully covered on this policy</span>
          </li>
          <li><span class="icon-times-thick green">Listed on all policy documents</span></li>
          <li><span class="icon-times-thick red">Cannot make policy changes</span></li>
        </ul>
        <div class="footer">
          If you have any further questions or concerns, please contact your agent.
        </div>
      </div>
    }
    @case ('addresschange') {
      <div class="flex-column">
        <div class="heading">Address change</div>
        <div class="pad-top-12 pad-bottom-30 gray-text font-weight-normal">
          We’ll mail any legally required documents to the new address, <br />
          even if you have paperless delivery.
        </div>
        <div class="flex justify-flex-end">
          <button ds-button class="link no-decoration" close>OK</button>
        </div>
      </div>
    }
    @default {
      <div>Invalid Context</div>
    }
  }
</div>
